declare var _gaq: any;

export class ScrolledHere {
    constructor() {
        const instances: NodeListOf<HTMLElement> = document.querySelectorAll("[data-scrolled-here]") as NodeListOf<HTMLElement>;
        if (instances && instances.length > 0) {
            for (let i = 0; i < instances.length; i++) {
                this.init(instances[i]);
            }
        }
    }

    private init(element: HTMLElement) {
        const name: string = element.getAttribute("data-scrolled-here");
        let viewed: boolean = false;
        window.addEventListener("scroll", () => {
            if (!viewed && this.isElementInViewport(element)) {        
                _gaq.push(["_trackEvent", "Interaction", `Scrolled To (${name})`, window.location.pathname, 0, false]); 
                viewed = true;                     
            }
        });  
    }

    private isElementInViewport(el: HTMLElement): boolean {
        if (el) {
            const rect: ClientRect = el.getBoundingClientRect();

            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        }
        return false;
    }

}



// WEBPACK FOOTER //
// ./src/global/ScrolledHere.ts